import { template } from "@ember/template-compiler";
import { Comment, isIntrinsic, Type } from '../renderer.gts';
import type { TOC } from '@ember/component/template-only';
const not = (x1: unknown)=>!x1;
export const NamedArgs: TOC<{
    Args: {
        kind: 'component' | 'modifier' | 'helper';
        info: any;
    };
}> = template(`
  {{#if @info}}
    <h3 class='typedoc-heading'>Arguments</h3>
    {{#each @info.type.declaration.children as |child|}}
      <span class='typedoc-{{@kind}}-arg'>
        <span class='typedoc-{{@kind}}-arg-info'>
          <pre class='typedoc-name'>@{{child.name}}</pre>
          {{#if (isIntrinsic child.type)}}
            <Type @info={{child.type}} />
          {{/if}}
        </span>
        {{#if (not (isIntrinsic child.type))}}
          <Type @info={{child.type}} />
        {{else}}
          <Comment @info={{child}} />
        {{/if}}
      </span>
    {{/each}}
  {{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvdWkvc3JjL3R5cGVkb2Mvc2lnbmF0dXJlL2FyZ3MuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbW1lbnQsIGlzSW50cmluc2ljLCBUeXBlIH0gZnJvbSAnLi4vcmVuZGVyZXIuZ3RzJztcblxuaW1wb3J0IHR5cGUgeyBUT0MgfSBmcm9tICdAZW1iZXIvY29tcG9uZW50L3RlbXBsYXRlLW9ubHknO1xuXG5jb25zdCBub3QgPSAoeDogdW5rbm93bikgPT4gIXg7XG5cbmV4cG9ydCBjb25zdCBOYW1lZEFyZ3M6IFRPQzx7XG4gIEFyZ3M6IHsga2luZDogJ2NvbXBvbmVudCcgfCAnbW9kaWZpZXInIHwgJ2hlbHBlcic7IGluZm86IGFueSB9O1xufT4gPSA8dGVtcGxhdGU-XG4gIHt7I2lmIEBpbmZvfX1cbiAgICA8aDMgY2xhc3M9J3R5cGVkb2MtaGVhZGluZyc-QXJndW1lbnRzPC9oMz5cbiAgICB7eyNlYWNoIEBpbmZvLnR5cGUuZGVjbGFyYXRpb24uY2hpbGRyZW4gYXMgfGNoaWxkfH19XG4gICAgICA8c3BhbiBjbGFzcz0ndHlwZWRvYy17e0BraW5kfX0tYXJnJz5cbiAgICAgICAgPHNwYW4gY2xhc3M9J3R5cGVkb2Mte3tAa2luZH19LWFyZy1pbmZvJz5cbiAgICAgICAgICA8cHJlIGNsYXNzPSd0eXBlZG9jLW5hbWUnPkB7e2NoaWxkLm5hbWV9fTwvcHJlPlxuICAgICAgICAgIHt7I2lmIChpc0ludHJpbnNpYyBjaGlsZC50eXBlKX19XG4gICAgICAgICAgICA8VHlwZSBAaW5mbz17e2NoaWxkLnR5cGV9fSAvPlxuICAgICAgICAgIHt7L2lmfX1cbiAgICAgICAgPC9zcGFuPlxuICAgICAgICB7eyNpZiAobm90IChpc0ludHJpbnNpYyBjaGlsZC50eXBlKSl9fVxuICAgICAgICAgIDxUeXBlIEBpbmZvPXt7Y2hpbGQudHlwZX19IC8-XG4gICAgICAgIHt7ZWxzZX19XG4gICAgICAgICAgPENvbW1lbnQgQGluZm89e3tjaGlsZH19IC8-XG4gICAgICAgIHt7L2lmfX1cbiAgICAgIDwvc3Bhbj5cbiAgICB7ey9lYWNofX1cbiAge3svaWZ9fVxuPC90ZW1wbGF0ZT47XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLFNBQVMsT0FBTyxFQUFFLFdBQVcsRUFBRSxJQUFJLFFBQVEsa0JBQWtCO0FBRTdELGNBQWMsR0FBRyxRQUFRLGlDQUFpQztBQUUxRCxNQUFNLE1BQU0sQ0FBQyxJQUFHLE9BQU8sR0FBSyxDQUFDO0FBRTdCLE9BQU8sTUFBTSxXQUFXO0lBQ3RCO1FBQVEsTUFBTSxjQUFjLGFBQWE7UUFBVSxNQUFNLEdBQUc7O0tBQ3pELFNBQVUsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQW1CZixDQUFBLEVBQUE7SUFBQTtRQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztJQUFEO0FBQUEsR0FBRSJ9